module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"login":"Войти","register":"Зарегистрироваться","stop-loosing":"Перестать ошибаться","auspiciousness":"Моя благоприятность","get-predictions":"Узнать прогнозы","get-rythm":"Найти свой ритм"}}')
  delete Component.options._Ctor
}
